import { z } from 'zod';
import { UnionOfKeys } from '@anytag/shared-types';
import { SearchSchema } from '@anytag/shared-validations';
import { TikTokSpecialCampaignStatus } from '@anytag/graphql';

export const TikTokCampaignsSearchSchema = SearchSchema.create({
  filter: {
    schema: z.object({
      keyword: SearchSchema.types.string(),
      status: SearchSchema.types.enum(TikTokSpecialCampaignStatus)
    })
  }
});

export type TikTokCampaignsSearchType = z.infer<typeof TikTokCampaignsSearchSchema>;
export type TikTokCampaignsFilterFormValues = TikTokCampaignsSearchType['filter'];
export type TikTokCampaignsFilterFormKeys = UnionOfKeys<TikTokCampaignsFilterFormValues>;
